import React from 'react';
import { Drawer, List, ListItem, ListItemButton, ListItemText, Toolbar } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface SidebarProps {
  role: 'superadmin' | 'client';
}

const Sidebar: React.FC<SidebarProps> = ({ role }) => {
  const navigate = useNavigate();

  const superadminItems = [
    { text: 'Dashboard', path: '/superadmin' },
    { text: 'Manage Clients', path: '/superadmin/clients' },
    { text: 'Client Vendors', path: '/superadmin/vendors' },
    { text: 'Prioritized Games', path: '/superadmin/prioritized-games' },
    { text: 'API Logs', path: '/superadmin/api-logs' },
    { text: 'Logout', path: '/logout' },
  ];

  const clientItems = [
    { text: 'Dashboard', path: '/client' },
    { text: 'Logout', path: '/logout' },
  ];

  const items = role === 'superadmin' ? superadminItems : clientItems;

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    navigate('/login');
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 240,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: 240, boxSizing: 'border-box', marginTop: '64px' },
      }}
    >
      <Toolbar />
      <List>
        {items.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              onClick={() =>
                item.path === '/logout' ? handleLogout() : navigate(item.path)
              }
            >
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;